import * as Moment from 'moment'
import { extendMoment } from 'moment-range'
import { DATE_FORMAT } from '@utils/constants'

const moment = extendMoment(Moment)

moment.locale('en', {
  week: {
    dow: 1,
    doy: 1,
  },
})

export const convertDateTimeToDate = (datetime, timeZoneName) => {
  const m = moment.tz(datetime, timeZoneName)
  return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0)
}

export const getMinMaxTime = (currentDate, events, loading, showAll) => {
  const mcd = moment(currentDate)
  const getStartEndOf = (m: Moment.Moment, method: 'startOf' | 'endOf') => m.clone()[method]('isoWeek')[method]('day')
  const weekEvents = events.filter(({ start = currentDate, end = currentDate }) => {
    const weekRange = moment.range(getStartEndOf(mcd, 'startOf'), getStartEndOf(mcd, 'endOf'))
    const schedRange = moment.range(start, end)
    return weekRange.overlaps(schedRange)
  })

  const getDates = (): Moment.Moment[] => {
    let splitEvents: Moment.Moment[] = []
    weekEvents.map((event) => {
      const sameDay = moment(event.start).isSame(event.end, 'day')
      const d = moment().format(DATE_FORMAT.BASIC)
      const start = moment(event.start)
      const end = moment(event.end)
      const startInWeek = moment(start).isBetween(getStartEndOf(mcd, 'startOf'), getStartEndOf(mcd, 'endOf'))
      const endInWeek = moment(end).isBetween(getStartEndOf(mcd, 'startOf'), getStartEndOf(mcd, 'endOf'))

      const eventStart = moment(`${d} ${start.format(DATE_FORMAT.HM)}`)
      const endOfEventStart = moment(`${d} ${start.clone().endOf('day').format(DATE_FORMAT.HM)}`)
      const endOfEventEnd = moment(`${d} ${end.clone().startOf('day').format(DATE_FORMAT.HM)}`)
      const eventEnd = moment(`${d} ${end.format(DATE_FORMAT.HM)}`)

      if (!sameDay && !startInWeek) {
        splitEvents = [...splitEvents, endOfEventEnd, eventEnd]
        return
      }

      if (!sameDay && !endInWeek) {
        splitEvents = [...splitEvents, eventStart, endOfEventStart]
        return
      }

      if ((!sameDay && event?.resource?.AllDay) || (!sameDay && (startInWeek || endInWeek))) {
        splitEvents = [...splitEvents, eventStart, endOfEventStart, endOfEventEnd, eventEnd]
        return
      }

      if (sameDay) {
        splitEvents = [...splitEvents, eventStart, eventEnd]
      }
      return
    })

    return splitEvents
  }

  const dates = getDates()

  const useDefault = loading || showAll || !dates.length
  const defaultMin = [moment().startOf('day')]
  const defaultMax = [moment().endOf('day')]
  const max = moment.max(useDefault ? defaultMax : dates)

  return {
    min: useDefault ? moment().startOf('day').toDate() : moment.min(useDefault ? defaultMin : dates).toDate(),
    max: useDefault
      ? moment().endOf('day').toDate()
      : (max.isSame(defaultMax[0], 'hour') ? defaultMax[0] : max).toDate(),
  }
}
